define('views/modals/messenger/message-item',['require','views/base/view','text!templates/modals/messenger/message-item.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/modals/messenger/message-item.ejs');

    var MessageItemView = View.extend({
        template: template,
        className: 'message-item',
        tagName: 'tr',
        listen: {
            'addedToParent': 'onAddedToParent'
        },
        onAddedToParent: function() {
            var _this = this;
            var fn = function () {
                _this.model.collection.trigger('resize');
            };
            this.$('img').load(fn).error(fn);
        }
    });

    return MessageItemView;
});
